import { DeleteIcon, EditIcon, SearchIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Td,
  Text,
  Tr,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import { addHours, format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaMicrophone } from "react-icons/fa";
import { BsYoutube } from "react-icons/bs";
import { useAuth } from "../../context/AuthContext";

const EventItem = ({ event, onDelete }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const auth = useAuth();

  const bucket = process.env.REACT_APP_S3_BUCKET; // "acaol-prod"
  const region = process.env.REACT_APP_S3_REGION; // "us-east-1"
  const folder = "events_images"; // sua pasta fixa no bucket

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{event.name}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex w={"100%"} gap={3} flexDir={"column"}>
              <Text>{event.theme}</Text>

              <Image
                src={`https://${bucket}.s3.${region}.amazonaws.com/${folder}/${event?.image}`}
                objectFit={"contain"}
                maxH={"300px"}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Voltar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Tr>
        <Td maxW="200px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" title={event.name} fontSize="0.82rem">{event.name}</Td>
        <Td fontSize="0.82rem" whiteSpace="nowrap">
          {format(
            new Date(addHours(new Date(event?.eventDate), 3)),
            "dd 'de' MMMM 'de' yyyy",
            {
              locale: ptBR,
            }
          )}
        </Td>
        <Td fontSize="0.82rem">{event.speakers.length}</Td>
        <Td fontSize="0.82rem">{event.listeners.length}</Td>
        <Td>
          <Flex gap={2}>
            <Tooltip label="Detalhes do evento">
              <IconButton
                colorScheme="green"
                variant="ghost"
                aria-label="Detalhes"
                size="xs"
                onClick={onOpen}
                icon={<SearchIcon />}
              />
            </Tooltip>

            {auth?.user.type === process.env.REACT_APP_ADMINISTRATOR && (
              <>
                <Tooltip label="Adicionar conteúdo do evento">
                  <IconButton
                    colorScheme="teal"
                    variant="ghost"
                    aria-label="Adicionar Conteúdo"
                    size="xs"
                    onClick={() => {
                      navigate(`/addEventContent/${event.eventId}`);
                    }}
                    icon={<BsYoutube />}
                  />
                </Tooltip>
                <Tooltip label="Excluir evento">
                  <IconButton
                    colorScheme="red"
                    variant="ghost"
                    aria-label="Excluir"
                    size="xs"
                    isLoading={isLoading}
                    onClick={() => {
                      setIsLoading(true);
                      onDelete(event.eventId);
                      setIsLoading(false);
                    }}
                    icon={<DeleteIcon />}
                  />
                </Tooltip>
                <Tooltip label="Editar evento">
                  <IconButton
                    colorScheme="orange"
                    variant="ghost"
                    aria-label="Editar"
                    size="xs"
                    isLoading={isLoading}
                    onClick={() => {
                      setIsLoading(true);
                      navigate(`/createEvent/${event.eventId}`);
                    }}
                    icon={<EditIcon />}
                  />
                </Tooltip>
              </>
            )}

            <Tooltip label="Ver inscritos do evento">
              <IconButton
                colorScheme="blue"
                variant="ghost"
                aria-label="Ver Inscritos"
                size="xs"
                isLoading={isLoading}
                onClick={() => {
                  setIsLoading(true);
                  navigate(`/eventInscriptions/${event.eventId}`);
                }}
                icon={<FaMicrophone />}
              />
            </Tooltip>
          </Flex>
        </Td>
      </Tr>
    </>
  );
};
export default EventItem;
